// test64
(64 && 0);
